module.exports = __webpack_public_path__ + "static/beton-71a47d4572ca57681a4c4fa25a9f34b4.svg";